import {
    GET_PRODUCTS,
    GET_SHOP_LOADING,
    GET_CATEGORIES,
    GET_FILTER,
    GET_TYPED_PRODUCTS,
    GET_FILTERED_PRODUCTS_BY_CATEGORY,
    GET_FILTERED_PRODUCTS_BY_CATEGORY_CASE,
    GET_FEATURES_FILTER,
    GET_FEATURES_FILTER_SELECTED,
    GET_TYPES_FILTER_SELECTED,
    GET_FILTERED_PRODUCTS_BY_FEATURES,
    GET_PRODUCTS_WITH_DISCOUNT,
    GET_FILTERS_SELECTED
} from "./types";

const lang = window.appLocale;

const groupByCat = (arr) => {
    return arr.reduce((acc, item) => {
        const { cat } = item;
        if (!acc[cat]) {
            acc[cat] = [];
        }
        acc[cat].push(item.id);
        return acc;
    }, {});
}

const shopGetters = {
    [GET_PRODUCTS](state) {
        return state.shopItems.sort(function(a, b){
            if(a.name[lang] < b.name[lang]) { return -1; }
            if(a.name[lang] > b.name[lang]) { return 1; }
            return 0;
        });
    },
    [GET_TYPED_PRODUCTS](state, getters) {
        return getters[GET_FILTER].type != '' ? getters[GET_PRODUCTS].filter(
            product => product.type == getters[GET_FILTER].type
        ): getters[GET_PRODUCTS];
    },
    [GET_PRODUCTS_WITH_DISCOUNT](state, getters) {
        return getters[GET_PRODUCTS].filter(product => product.has_any_active_discount);
    },
    [GET_FILTERED_PRODUCTS_BY_CATEGORY](state, getters) {
        return getters[GET_FILTER].category.id
            ? getters[GET_FILTERED_PRODUCTS_BY_FEATURES].filter(
                  product => product.category_id == getters[GET_FILTER].category.id
              )
            : getters[GET_FILTERED_PRODUCTS_BY_FEATURES];
    },

    [GET_FILTERED_PRODUCTS_BY_CATEGORY_CASE]: (state, getters) => {
        const filteredProducts = getters[GET_FILTERED_PRODUCTS_BY_FEATURES];

        switch (getters[GET_FILTER].category.case) {
          case "all":
            return filteredProducts;
          case "discount":
            return filteredProducts.filter(product => product.has_any_active_discount);
          case "newArrival":
            return filteredProducts.filter(product => product.new_arrival);
          default:
            const categoryId = getters[GET_FILTER].category.id
            return filteredProducts.filter(
              product => product.category_id === categoryId
            );
        }
    },

    [GET_FILTERED_PRODUCTS_BY_FEATURES](state, getters) {
        if(getters[GET_FEATURES_FILTER_SELECTED].length == 0 && getters[GET_TYPES_FILTER_SELECTED] == null) return getters[GET_TYPED_PRODUCTS];

        //Iterate over every product checking setted featured filters
        return getters[GET_TYPED_PRODUCTS].filter(product => {
            const properitesIds = product.properties.map(p => p.id);

            let featuresFilterSelected = [];

            getters[GET_TYPES_FILTER_SELECTED] ? featuresFilterSelected = [getters[GET_TYPES_FILTER_SELECTED]] : '';
            getters[GET_FEATURES_FILTER_SELECTED].length ? featuresFilterSelected = [...featuresFilterSelected, ...getters[GET_FEATURES_FILTER_SELECTED]] : '';

            const featuresFilterSelectedGrouped = groupByCat(featuresFilterSelected);

            //AND condition between categories
            return Object.values(featuresFilterSelectedGrouped).every(filterIds => {
                //OR condition between properties
                return filterIds.some(filterId => properitesIds.includes(filterId))
            })
        });
    },
    [GET_FILTERS_SELECTED](state, getters) {

        let filtersSelected = [];
        let typesFilterSelected = [];
        let featuresFilterSelected = [];

        getters[GET_FEATURES_FILTER_SELECTED] ? filtersSelected = [...getters[GET_FEATURES_FILTER_SELECTED]] : [];
        getters[GET_TYPES_FILTER_SELECTED] ? typesFilterSelected = [getters[GET_TYPES_FILTER_SELECTED]] : [];

        featuresFilterSelected = [...filtersSelected, ...typesFilterSelected];

        return featuresFilterSelected;
    },
    [GET_SHOP_LOADING](state) {
        return state.shopLoading;
    },
    [GET_CATEGORIES](state) {
        return state.categories;
    },
    [GET_FILTER](state) {
        return state.filter;
    },
    [GET_FEATURES_FILTER](state){
        return state.featuresFilter;
    },
    [GET_FEATURES_FILTER_SELECTED](state, getters){
        return state.featuresFilterSelected
    },
    [GET_TYPES_FILTER_SELECTED](state, getters){
        return state.typesFilterSelected
    },
};

export default shopGetters;
